(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pp-product-colors"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('pp-product-colors')) {
    customElements.define(
      'pp-product-colors',
      class PPProductColors extends HTMLElement {
        connectedCallback() {
          this.inputs = Array.from(this.querySelectorAll('[data-pp-property]'));
          if (this.inputs.length === 0) return;

          this.form = document.querySelector('#MainContent product-form form[data-type="add-to-cart-form"]');
          if (!this.form) return;

          if (!this.form.id) this.form.id = 'pp-product-form-' + Date.now();
          this.inputs.forEach((input) => input.setAttribute('form', this.form.id));
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pp-product-extras"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('pp-product-extras')) {
    customElements.define(
      'pp-product-extras',
      class PPProductExtras extends HTMLElement {
        connectedCallback() {
          this.checkboxes = Array.from(this.querySelectorAll('[data-pp-extra]'));
          this.properties = Array.from(this.querySelectorAll('[data-pp-property]'));
          this.summary = this.querySelector('[data-pp-extras-summary]');
          this.total = this.querySelector('[data-pp-extras-total]');
          this.error = this.querySelector('[data-pp-extras-error]');
          this.form = document.querySelector('#MainContent product-form form[data-type="add-to-cart-form"]');
          if (!this.form || (this.checkboxes.length === 0 && this.properties.length === 0)) return;

          if (!this.form.id) this.form.id = `pp-product-form-${Date.now()}`;
          this.properties.forEach((property) => property.setAttribute('form', this.form.id));

          this.submitButton = this.form.querySelector('[type="submit"]');
          this.dynamicCheckout = this.form.querySelector('.shopify-payment-button');
          this.dynamicCheckoutWasHidden = this.dynamicCheckout ? this.dynamicCheckout.hidden : false;
          this.onSubmit = this.handleSubmit.bind(this);
          this.form.addEventListener('submit', this.onSubmit, true);
          this.checkboxes.forEach((checkbox) => checkbox.addEventListener('change', () => this.paint()));
          this.paint();
        }

        disconnectedCallback() {
          if (this.form && this.onSubmit) this.form.removeEventListener('submit', this.onSubmit, true);
        }

        selectedExtras() {
          return this.checkboxes.filter((checkbox) => checkbox.checked && !checkbox.disabled);
        }

        paint() {
          const selected = this.selectedExtras();
          const total = selected.reduce((sum, checkbox) => sum + Number(checkbox.dataset.priceCents || 0), 0);

          if (this.summary && this.total) {
            this.summary.hidden = total === 0;
            this.total.textContent = this.formatMoney(total);
          }

          if (this.dynamicCheckout) {
            this.dynamicCheckout.hidden = selected.length > 0 ? true : this.dynamicCheckoutWasHidden;
          }
        }

        formatMoney(cents) {
          return new Intl.NumberFormat(this.dataset.locale || 'it-IT', {
            style: 'currency',
            currency: this.dataset.currency || 'EUR',
          }).format(cents / 100);
        }

        propertiesFromForm(formData) {
          const properties = {};
          for (const [name, value] of formData.entries()) {
            const match = name.match(/^properties\[(.+)\]$/);
            if (match && String(value).trim() !== '') properties[match[1]] = value;
          }
          return properties;
        }

        async handleSubmit(event) {
          if (event.defaultPrevented) return;
          const extras = this.selectedExtras();
          if (extras.length === 0) return;

          event.preventDefault();
          event.stopImmediatePropagation();
          this.hideError();

          const formData = new FormData(this.form);
          const variantId = Number(formData.get('id'));
          const quantity = Math.max(1, Number(formData.get('quantity') || 1));
          if (!variantId) {
            this.showError(this.dataset.errorLabel);
            return;
          }

          const items = [
            {
              id: variantId,
              quantity,
              properties: this.propertiesFromForm(formData),
            },
          ];

          extras.forEach((checkbox) => {
            items.push({
              id: Number(checkbox.dataset.variantId),
              quantity: checkbox.dataset.matchQuantity === 'true' ? quantity : 1,
              properties: {
                _Tipo: checkbox.dataset.kind,
                _Aggiunta: checkbox.dataset.lineLabel,
                _Per: this.dataset.productTitle,
              },
            });
          });

          const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
          const body = { items };
          if (cart && typeof cart.getSectionsToRender === 'function') {
            body.sections = cart.getSectionsToRender().map((section) => section.id);
            body.sections_url = window.location.pathname;
            if (typeof cart.setActiveElement === 'function') cart.setActiveElement(document.activeElement);
          }

          this.setBusy(true);

          try {
            const url =
              window.routes && window.routes.cart_add_url
                ? window.routes.cart_add_url
                : `${window.Shopify.routes.root}cart/add.js`;
            const response = await fetch(url, {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
                'X-Requested-With': 'XMLHttpRequest',
              },
              body: JSON.stringify(body),
            });
            const payload = await response.json();
            if (!response.ok || payload.status) {
              throw new Error(payload.description || payload.message || this.dataset.errorLabel);
            }

            if (cart && payload.sections && typeof cart.renderContents === 'function') {
              cart.classList.remove('is-empty');
              cart.renderContents(payload);
            } else {
              window.location.assign(window.routes ? window.routes.cart_url : `${window.Shopify.routes.root}cart`);
            }
          } catch (error) {
            this.showError(error.message || this.dataset.errorLabel);
          } finally {
            this.setBusy(false);
          }
        }

        setBusy(busy) {
          if (!this.submitButton) return;
          this.submitButton.toggleAttribute('aria-disabled', busy);
          this.submitButton.classList.toggle('loading', busy);
          const spinner = this.submitButton.querySelector('.loading__spinner');
          if (spinner) spinner.classList.toggle('hidden', !busy);
        }

        showError(message) {
          if (!this.error) return;
          this.error.textContent = message || this.dataset.errorLabel;
          this.error.hidden = false;
          this.error.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }

        hideError() {
          if (!this.error) return;
          this.error.hidden = true;
          this.error.textContent = '';
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
